export const X_FLOG_ID = 'x-flog-id';
export const X_FLOG_REQ_NUM = 'x-flog-req-num';

export type FlogHeaders = {
  [X_FLOG_ID]: string;
  [X_FLOG_REQ_NUM]?: string;
};
